"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgLinkedin24 = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", role: "img" }, props, { children: (0, jsx_runtime_1.jsxs)("g", __assign({ fill: "none", fillRule: "evenodd" }, { children: [(0, jsx_runtime_1.jsx)("path", { d: "M0 .5h24v24H0z" }), (0, jsx_runtime_1.jsx)("path", { d: "M19.15 4.7H4.85c-.39 0-.65.26-.65.65v14.3c0 .39.26.65.65.65h14.3c.39 0 .65-.26.65-.65V5.35c0-.39-.26-.65-.65-.65zM8.815 18.025H6.54V10.55h2.34v7.475h-.065zM7.645 9.51A1.373 1.373 0 0 1 6.28 8.145c0-.715.585-1.365 1.365-1.365.715 0 1.365.585 1.365 1.365S8.425 9.51 7.645 9.51zm9.88 8.515h-2.34v-3.64c0-.845 0-1.95-1.17-1.95-1.235 0-1.365.91-1.365 1.885v3.705h-2.34V10.55h2.21v1.04c.325-.585 1.04-1.17 2.21-1.17 2.34 0 2.795 1.56 2.795 3.575v4.03z", fill: "currentColor" })] })) }))); };
exports.default = SvgLinkedin24;
